//this query is used for edit and copy for ww for availability localization
export const createLocalizationAvailability= `mutation CreateLocalizationAvailability($input: CreateLocalizationAvailabilityRequest!) {
  createLocalizationAvailability(input: $input) {
    pkId
    version
    region
    productFamily
    productGroup
    category
    feature
    featureValue
    featureDesc
    country
    businessGroup
    startDate
    endDate
    comments
    status
    countryDesc
    apRegion
    euRegion
    naRegion
    laRegion
    whoChanged
    createDate
    lastModifiedDate
    message
  }
}`
//this query is used for edit and copy for other regional for availability localization
export const copyRegionalLocalization = `mutation CopyRegionalLocalization($input: CreateRegionalLocalizationRequest!) {
  copyRegionalLocalization(input: $input) {
    pkId
    version
    region
    productFamily
    productGroup
    productDesc
    category
    feature
    featureValue
    featureDesc
    country
    businessGroup
    wwStartDate
    wwEndDate
    regStartDate
    regEndDate
    comments
    status
    countryDesc
    whoChanged
    createDate
    lastModifiedDate
    message
  }
}`